import { EntityLookupItemDto } from '@feature/pma-entity/pma-entity-types';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject,  Observable,  tap,  mapTo, map } from 'rxjs';
import { Subject } from './responsive-contact-us.types';
import { PmaEntityLookupHttpService } from '@feature/pma-entity/services/pma-entity-lookup-http.service';

@Injectable({
    providedIn: 'root'
})
export class ContactUsService {
    private _subjects: BehaviorSubject<Subject[]> = new BehaviorSubject<Subject[]>(null);
    private _units: BehaviorSubject<EntityLookupItemDto[]> = new BehaviorSubject<EntityLookupItemDto[]>(null);
    private _tenants: BehaviorSubject<EntityLookupItemDto[]> = new BehaviorSubject<EntityLookupItemDto[]>(null);


    get subjects$(): Observable<Subject[]>
    {
        return this._subjects.asObservable();
    }

    get units$(): Observable<EntityLookupItemDto[]>
    {
        return this._units.asObservable();
    }

    get tenants$(): Observable<EntityLookupItemDto[]>
    {
        return this._tenants.asObservable();
    }

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient,
        private readonly lookupService: PmaEntityLookupHttpService,
        private readonly urlBuilderService: UrlBuilderService) {
    }

    getTenantDetailsByKey( key ) {
        const url = this.urlBuilderService.getUrl('tenant/details');
        return this._httpClient.post(url, key);
    }

    getEmailByKey(key): Observable<string>{
        const url = this.urlBuilderService.getUrl('email-lookup/by-key');
        return this._httpClient.post<GetEmailForEntityKeyResponse>(url, key).pipe(map(response => response?.Email || undefined));
    }

    /**
     * Get Subjects
     */
    getSubjects(): Observable<Subject[]> {
        const url = this.urlBuilderService.getUrl('contact-us-subjects/all');
        return this._httpClient.get<Subject[]>(url).pipe(
            tap((response: Subject[]) => {
                this._subjects.next(response);
            })
        );
    }

    /**
     * Get Unit Addresses
     */
    getEntityLookupItems(entityType: string): Observable<EntityLookupItemDto[]> {
        return this.lookupService.lookup(entityType, '').pipe(
            tap((response: EntityLookupItemDto[]) => {
                this._units.next(response);
            })
        );
    }

    send(form, files, product: string) {
        const url = this.urlBuilderService.getMojoApiUrl('eas/calls/createCall');
        const formData = new FormData();

        files.forEach(file => {
            formData.append('files', file);
        });
        formData.append('request', JSON.stringify(form));
        formData.append('product', product)
        return this._httpClient.post(url, formData).pipe(mapTo(true));
      }
}

interface GetEmailForEntityKeyResponse {
    Email: string;
  }
